module.exports = __webpack_public_path__ + "img/13.646c4398.jpg";